import React from 'react';
import { faSearch, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDashboardContext } from '../../context';
import { useGlobalContext } from '../../../../globalContext';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import CustomToast from '../../../../components/Toast';

const Reply = (props) => {
  const {
    sendEmailModal,
    setSendEmailModal,
    selectRecipient,
    getAllStudents,
    setSelectRecipient,
    slectedStudents,
    sendMessageHandler,
    isReplayMessage,
    setIsReplayMessage,
    setSlectedStudents
  } = useDashboardContext();
  const {getAllAlertsAsync} = useGlobalContext();
  
  const [fromUser] = React.useState(props.fromUser);
  const [subject, setSubject] = React.useState(
    props.subject.toLowerCase().startsWith('re:') ? `${props.subject}` : `Re: ${props.subject}`
  );
  const [message, setMessage] = React.useState('');
  const location = useLocation();

  const sendHandler = async () => {
    if (message === '') {
      CustomToast('Please enter message', 'error');
      return;
    }
    if (slectedStudents.length == 0) {
      return;
    }

    props.close(false);
    const isSentMessages = location.pathname.endsWith('/sent');
    const data = {
      subject: subject,
      message: message,
      recipientIds: slectedStudents.map((obj) => obj.studentId)
    };
    try {
      await sendMessageHandler(data);
      if (isSentMessages) {
        getAllAlertsAsync(2);
      } else {
        getAllAlertsAsync(1);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleSubjectChange = (event) => {
    let newSubject = event.target.value;
    setSubject(newSubject);
  };

  const selectRecipientHandler = () => {
    setSendEmailModal(!sendEmailModal);
    setSelectRecipient(!selectRecipient);
    getAllStudents();
  };

  const removeSelectedStudents = (student) => {
    setSlectedStudents((prevSelectedStudents) => {
      return prevSelectedStudents.filter((s) => s !== student);
    });
  };

  return (
    <div className="white-card mt-4">
      <div className="row">
        <div className="col-lg-6 mb-3">
          <label className="form-label">
            To <small className="opacity-75">(Enter either a login id or a user&#39;s name)</small>
          </label>
          <div className=" position-relative">
            <div
              onClick={selectRecipientHandler}
              className="form-control selected-emails d-flex flex-wrap gap-2 align-items-center overflow-auto">
              <FontAwesomeIcon icon={faSearch} />
              {slectedStudents.map((student, index) => (
                <span key={index}>
                  {`${student.fName} ${student.lName}`}
                  <FontAwesomeIcon
                    onClick={(event) => {
                      event.stopPropagation();
                      removeSelectedStudents(student);
                    }}
                    icon={faTimesCircle}
                  />
                </span>
              ))}
            </div>
          </div>
        </div>
        <div className="col-lg-6 mb-3">
          <label className="form-label">Subject</label>
          <input
            value={subject}
            onChange={handleSubjectChange}
            type="text"
            placeholder=""
            className="form-control"
          />
        </div>
        <div className="col-12 mb-3">
          <label className="form-label">Message</label>
          <textarea
            className="form-control"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            id="exampleFormControlTextarea1"
            rows="5"></textarea>
        </div>
        <div className="col-12 d-flex justify-content-end">
          <button
            style={{ width: '100px' }}
            onClick={() => props.close(false)}
            className="btn-castleGray me-2">
            Cancel
          </button>
          <button onClick={sendHandler} className="btn primary-btn">
            Send
          </button>
        </div>
      </div>
    </div>
  );
};

Reply.propTypes = {
  fromUser: PropTypes.string,
  fromUserId: PropTypes.number,
  close: PropTypes.func,
  subject: PropTypes.string
};

export default Reply;
